import AuthSelectLanguageComponent from "./AuthSelectLanguageComponent";

export default AuthSelectLanguageComponent;
